export const filterOptions = (options, query) => {
    if (!options?.length || !query?.trim()) {
        return options;
    }
    return options.filter((_) => _.text?.toLocaleLowerCase().includes(query?.trim().toLocaleLowerCase()));
};
//# sourceMappingURL=filterOptions.js.map